var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.99744H4.5C3.7998 3.99744 3.7998 4.99677 4.5 4.99677H10.5C11.0996 4.99677 11.1992 3.99744 10.5 3.99744Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.99548H8.5C9.19922 6.99548 9.09961 7.99481 8.5 7.99481H4.5C3.7998 7.99481 3.7998 6.99548 4.5 6.99548Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0H15C15.5996 0 16 0.399719 16 0.999329V10.9929C16 11.5926 15.5996 11.9923 15 11.9923H6.40039L4.7002 13.6912C4 14.3907 3 13.7911 3 12.9916V11.9923H1C0.400391 11.9923 0 11.5926 0 10.9929V0.999329C0 0.399719 0.400391 0 1 0ZM2 9.99359H14V1.99872H2V9.99359Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNavIcon);
export default __webpack_public_path__ + "static/media/ChatNavIcon.6ab6adefe0e3e849b5a79ab6fb5b6625.svg";
export { ForwardRef as ReactComponent };